import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { ItemMasterProposal } from '../../models/item-master-proposal';

@Injectable({
  providedIn: 'root',
})
export class ItemMasterProposalProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item-master-proposals';

  public getAll(): Observable<ApiResponse<ItemMasterProposal[]>> {
    return this.httpClient.get<ApiResponse<ItemMasterProposal[]>>(`${this.baseUrl}/all`);
  }

  public create(): Observable<ApiResponse<ItemMasterProposal>> {
    return this.httpClient.post<ApiResponse<ItemMasterProposal>>(this.baseUrl, {});
  }
}
